/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useEffect } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import PageLayout from "../components/Common/PageLayout";
import PageBanner from "../components/Common/PageBanner";

const Guidelines = () => {
  const state = useSelector((state) => state) || {};
  const isAuthenticated = state?.auth?.isAuthenticated || false;
  const meetingsData = state?.pageContents?.meetings?.data;
  const navigate = useNavigate();

  // Redirect to login if not authenticated
  useEffect(() => {
    if (!isAuthenticated) {
      navigate("/login?redirect=/guidelines");
    }
  }, [isAuthenticated, navigate]);

  // Return early if not authenticated
  if (!isAuthenticated) {
    return null;
  }

  return (
    <PageLayout pageName="Guidelines">
      <PageBanner
        bannerImage={meetingsData?.meetingbanner?.banner_image}
        mainTitle="Guidelines"
        pageTitle="Guidelines"
      />

      <div className="doctors-details-area pt-100 guid-margin">
        <div className="container">
          <div className="row">
            <div className="col-md-12">
              <div className="section-title bene-title guidline-sec">
                <p>
                  This is the place where you will be able to find Guidelines
                  and Position Statements concerning Maternal-Fetal Anesthesia.
                </p>
              </div>
            </div>
          </div>

          {/* Request a Guideline */}
          <div className="prev-sec-inner">
            <div className="row">
              <div className="col-md-12">
                <div className="prev-meet-main guid-main-sec">
                  <div className="prev-meet-sec-right guid-para-sec">
                    <h2>REQUEST A GUIDELINE</h2>
                    <p>
                      If you would like SPANZA to consider the production of a
                      statement, guideline or advice in any specific area,
                      please CLICK HERE to submit an outline of your request
                      detailing the area of interest and the issues being faced,
                      and how such a document would support the work of
                      anaesthetists and improve the care of children.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* SPANZA Advisory */}
          <div className="prev-sec-inner">
            <div className="row">
              <div className="col-md-12">
                <div className="prev-meet-main guid-main-sec">
                  <div className="prev-meet-sec-right guid-para-sec">
                    <h2>
                      SPANZA Advisory on neurotoxicity of general anaesthesia
                      for infants and children
                    </h2>
                    <p>
                      <i>Developed April 2023.</i>{" "}
                    </p>
                    <p>
                      SPANZA are delighted to share with you the SPANZA Advisory
                      on neurotoxicity of general anaesthesia for infants and
                      children.
                    </p>
                    <p>
                      Please <a className="guid-link">CLICK HERE</a> to go to
                      the document.
                    </p>
                    <p>
                      <i>
                        SPANZA would like to acknowledge the work of members in
                        reviewing this document: A/ Prof Paul Lee-Archer, Qld;
                        Prof Andrew Davidson, Vic; Dr Sebastian King, Vic; Dr
                        Jonathan De Lima, NSW; Dr Fiona Macfarlane, Qld
                      </i>
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* SPANZA Sustainability Position Statement */}
          <div className="prev-sec-inner">{/* ...existing code... */}</div>

          {/* PG29 */}
          <div className="prev-sec-inner">{/* ...existing code... */}</div>

          {/* ANZCA professional document PG07 */}
          <div className="prev-sec-inner">{/* ...existing code... */}</div>
        </div>
      </div>
    </PageLayout>
  );
};

export default Guidelines;
